module.exports = __webpack_public_path__ + "static/media/ok-hand.bc8c0da6.png";